var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c(
      "div",
      { staticClass: "d-flex flex-column" },
      [
        _c("input", {
          attrs: { type: "hidden", name: _vm.field.fieldName },
          domProps: { value: _vm.field.value },
        }),
        _vm._v(" "),
        _c(
          "v-radio-group",
          {
            attrs: { row: "", autocomplete: "" },
            model: {
              value: _vm.depositRequired,
              callback: function ($$v) {
                _vm.depositRequired = $$v
              },
              expression: "depositRequired",
            },
          },
          [
            _c("v-radio", { attrs: { label: "Yes", value: 1 } }),
            _vm._v(" "),
            _c("v-radio", { attrs: { label: "No", value: 0 } }),
            _vm._v(" "),
            _c("v-radio", { attrs: { label: "Sometimes", value: 2 } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }